import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Impresa } from '../models/impresa.model';
import { Centrale } from '../models/centrale.models';
import { RichiestaAggiornamentoCentrale } from '../models/richiestaAggiornamentoCentrale.models';
import { Listino } from '../models/listino.model';
import { ListinoNazionale } from '../models/listinoNazionale.model';
import { PfIsReady } from '../models/dto/pfIsReady.model';
import { ModificaPF } from '../models/dto/modificaPF.model';
import { ProntofibraDTO } from '../models/prontofibra.dto.model';


@Injectable({
  providedIn: 'root',
})
export class ProntofibraService{
  apiUrl: string = environment.apiUrl+"prontofibra";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

  get(): Observable<any> {
    const headers = {
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }

  
  getById(id:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+id, httpOptions);
  }

  getStorico(id:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+id+"/storico", httpOptions);
  }

  sollecita(id:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl+"/"+id+"/sollecito", null,httpOptions);
  }

  presidioComunicaPfIsReady(idPf:number, pfIsReady:PfIsReady): Observable<any> {
    const urlFinale = this.apiUrl+"/"+idPf+"/pf-pronto";
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, pfIsReady, httpOptions)
  }

  modifica(idPf:number, pf:ProntofibraDTO): Observable<any> {
    const urlFinale = this.apiUrl+"/"+idPf;
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(urlFinale, pf, httpOptions)
  }

  modificaCategoriaKO(idPf:number, pf:ProntofibraDTO): Observable<any> {
    const urlFinale = this.apiUrl+"/"+idPf+"/causa-ko";
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, pf, httpOptions)
  }

  sollecitaMassivamente(file: File, numeroRecord:string, bando:string): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    const formData = new FormData();
    formData.append('file', file);
    formData.append('numeroRecord', numeroRecord);
    formData.append('bando', bando);
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl+"/sollecito", formData,httpOptions);
  }

  modificaDataInstallazione(idPf:number,pf:ModificaPF): Observable<any> {
    const urlFinale = this.apiUrl+"/"+idPf+"/modifica";
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, pf, httpOptions)
  }
  
  crea(listino:Listino): Observable<any> {
    const headers = {
      //  'Authorization': `Bearer ${token}`,
      };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, listino, httpOptions);
  }

  elimina(idListino:string): Observable<any> {
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idListino, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminaListino', []))
    );
  }

  eliminaConfigurazione(idListino:string, regione:string): Observable<any> {
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idListino+"/"+regione, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminaListino', []))
    );
  }

  private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };

}